import { Store } from '../../../../helpers';
import { setIsPressed } from '../../dataLayers/redux/dataLayers.actions';
import { clearDataLayers } from '../../dataLayers/controllers/dataLayers.controller';
import { setSelectedSwitch } from '../../polygons/redux/polygonsActions';
import {
  changeSearch,
  clearMap,
  closeAllCharts,
  setDisplayCharts,
  setIsActive,
} from '../../redux/dashboardActions';
import {
  resetGeocodeSocioeconomicDemographic,
  setShouldCleanPolygonsOnMap,
} from '../../socioeconomicDemographic/redux/socioeconomicDemographic.actions';
import { cleanHeatmap } from '../../heatmap/controllers/heatmap.controller';

export const cleaningMap = (): void => {
  cleanHeatmap();
  Store.dispatch([
    setDisplayCharts(''),
    clearDataLayers(),
    setSelectedSwitch(''),
    clearMap(),
    resetGeocodeSocioeconomicDemographic(),
    setDisplayCharts(null),
    setShouldCleanPolygonsOnMap(false),
    closeAllCharts(),
  ]);
};

export const limparActionMap = () => {
  Store.dispatch(setIsActive({ name: 'mapAction', value: '' }));
  const input = document.getElementById('input-searchbox') as HTMLInputElement;
  input.value = '';
};

export const cleanMapActions = () => {
  Store.dispatch(setIsPressed(false));
  cleaningMap();
  limparActionMap();
  Store.dispatch(changeSearch({ name: 'isFetched', value: false }));
};
